const state = {
  listOptions: {
    self: null,
    publicType: '0,1,2,3',
    oids: null,
    hids: null,
    dids: null,
    start: null,
    end: null,
    match: null
  },
  listPagination: {
    sort: 'updateTime',
    order: 'DESC',
    size: 10,
    total: 0,
    current: 1,
    layout: 'total, sizes, prev, pager, next, jumper',
    sizes: [10, 20, 50]
  }
}

const mutations = {
  setListPagination (state, pagination) {
    for (let key in state.listPagination) {
      if (pagination.hasOwnProperty(key)) {
        state.listPagination[key] = pagination[key]
      }
    }
  },
  setListOptions (state, options) {
    for (let key in state.listOptions) {
      if (options.hasOwnProperty(key)) {
        state.listOptions[key] = options[key]
      }
    }
  }
}

const actions = {
}

const getters = {
  listPagination (state) {
    return state.listPagination
  },
  listOptions (state) {
    return state.listOptions
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
